import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

declare let pendo: any;

@Injectable({
  providedIn: 'root',
})
export class PendoService {
  constructor(private router: Router) {}

  getAccountId() {
    const host = window?.location?.host || '';
    if (host === '') return 'NA';
    if (host === 'localhost:4300') {
      return 'Developer';
    }
    return host.split('.')[0];
  }

  initialize(userId: string) {
    pendo.initialize({
      visitor: {
        id: userId, // Required if user is logged in
        email: userId, // Recommended if using Pendo Feedback, or NPS Email
        // full_name:    // Recommended if using Pendo Feedback
        // role:         // Optional

        // You can add any additional visitor level key-values here,
        // as long as it's not one of the above reserved names.
      },
      account: {
        id: this.getAccountId(), // Required if using Pendo Feedback
        // name:         // Optional
        // is_paying:    // Recommended if using Pendo Feedback
        // monthly_value:// Recommended if using Pendo Feedback
        // planLevel:    // Optional
        // planPrice:    // Optional
        // creationDate: // Optional

        // You can add any additional account level key-values here,
        // as long as it's not one of the above reserved names.
      },
    });
  }
}
